import { Grid, List } from 'shared/components/Base/Base'
import { Button } from 'shared/components/Button/Button'
import { TextV2 } from 'shared/components/Text/TextV2'
import { TYPOGRAPHY } from 'shared/theme/typographyV2'

interface ConsultantConversationExamplesProps {
  questionExamples: string[]
  onMessage: (value: string) => Promise<void>
}

export function ConsultantConversationExamples({
  questionExamples,
  onMessage,
}: ConsultantConversationExamplesProps) {
  return (
    <div className="bg-information shadow-soft after:bg-information relative mb-8 w-[calc(100%-52px)] rounded-md p-8 after:absolute after:-bottom-2 after:left-[33px] after:h-5 after:w-5 after:rotate-45 after:content-[''] sm:p-5">
      <TextV2 type={TYPOGRAPHY.uppercaseLabel3} className="text-mid-gray">
        Try questions like...
      </TextV2>

      <List className="mb-0 space-y-8">
        {questionExamples.map((question, i) => (
          <li key={String(i)}>
            <Grid gap="10px" columns="1fr 80px">
              <TextV2 type={TYPOGRAPHY.header3}>{question}</TextV2>
              <Button variant="secondary" size="small" onClick={() => onMessage(question)}>
                Ask Cai
              </Button>
            </Grid>
          </li>
        ))}
      </List>
    </div>
  )
}
